import { createRouter, createWebHistory } from 'vue-router'
import { authStore } from "@/stores/auth";
import { layoutStore } from "@/stores/layout";
import { filterStore } from "@/stores/filter";
import { apm } from '@elastic/apm-rum';

const DEFAULT_TITLE = 'Insting';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/report/ReportValidation'),
      meta: {
        requiresIsAdmin: false,
      },
    },

    //-- general
    {
      path: "/reportvalidation",
      name: "report_validation",
      component: () => import("@/views/report/ReportValidation"),
      meta: {
        requiresIsAdmin: false,
        title: "Pencarian",
      },
    },
    {
      path: "/reportstatus",
      name: "report_status",
      component: () => import("@/views/report/ReportStatus"),
      meta: {
        requiresIsAdmin: false,
        title: "Status Laporan",
      },
    },
    {
      path: "/reportconfirmation",
      name: "report_confirmation",
      component: () => import("@/views/report/ReportConfirmation"),
      meta: {
        requiresIsAdmin: false,
        title: "Konfirmasi Laporan",
      },
    },
    {
      path: "/reportsearch",
      name: "report_search",
      component: () => import("@/views/report/ReportSearch"),
      meta: {
        requiresIsAdmin: false,
        title: "Pencarian",
      },
    },

    //-- iam
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/iam/MainLogin.vue"),
      meta: {
        guest: true,
        title: "Insting Login",
      }
    },
    {
      path: "/users",
      name: "users",
      component: () => import("@/views/iam/AccessUser.vue"),
      meta: {
        title: "Pengguna",

      }
    },
    {
      path: "/roles",
      name: "roles",
      component: () => import("@/views/iam/AccessRole.vue"),
      meta: {

        title: "Peran",
      }
    },
    {
      path: "/setting",
      name: "settings",
      component: () => import("@/views/iam/Setting.vue"),
      meta: {

        title: "Pengaturan",
      }
    },
    {
      path: "/healthcheck",
      name: "healthcheck",
      component: () => import("@/views/iam/HealthCheck.vue"),
      meta: {
        guest: true,
        title: "Health Check",
      }
    },
    {
      path: "/logs",
      name: "log",
      component: () => import("@/views/report/AuditTrail.vue"),
      meta: {
        title: "Riwayat Aktivitas",

      }
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: () => import("@/views/report/Dashboard.vue"),
      meta: {
        title: "Dashboard",
      }
    },
    {
      path: "/monitorhazard",
      name: "monitor_hazard",
      component: () => import("@/views/report/MonitorHazard.vue"),
      meta: {
        title: "Monitoring Hazard",
      }
    },
    {
      path: "/menu",
      name: "menu",
      component: () => import("@/views/iam/AccessMenu.vue"),
      meta: {
        title: "Menu",
      }
    },
    {
      path: "/profile",
      name: "profile",
      component: () => import("@/views/iam/Profile.vue"),
      meta: {
        title: "Profil",
      }
    },
  ]
})


router.beforeEach(async (to, from, next) => {
  const auth = authStore();
  const layout = layoutStore();

  if (to.matched.some((record) => record.meta.guest)) {
    layout.change("clear");
    next();
  } else {

    const configuration = JSON.parse(localStorage.getItem("config"));

    if (auth.appTokenInsting == "" || auth.appTokenInsting == undefined || !configuration) {
      next({
        path: '/login',
      });
    } else {
      // success authentication
      layout.name = "default";
      next();
    }
  }
});

router.afterEach((to, from) => {
  const filter = filterStore();
  // console.log(to)
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  // Vue.nextTick(() => {
  document.title = to.meta.title || DEFAULT_TITLE;
  // });

  apm.setCustomContext({
    page: to.name,
    path: to.path,
    fromPage: from.name,
    fromPath: from.path
  });
  apm.setInitialPageLoadName(to.name);

  if (to.name != "report_search" && to.name != "report_validation" && to.name != "report_confirmation" && to.name != "report_status") {
    filter.clear();
  }
});

export default router